import { getSessionToken } from "../../services/bootstrap";

export default {
    state() {
        return {
            //emails: [],
            //emailKB : [],
            significantTags: [],
            userJourney: null
        }
    },
    actions: {
        async getUserJourney(context) {
            let res = await fetch(`${context.getters.persistenceServiceAPI}/UserJourney/Dynamic/${context.getters.JWT}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    ApiKey: context.getters.apiKey
                },
                method: "GET"
            })
            let userJourney = await res.json();
            context.commit('userJourney', userJourney)
        },
        async getEmails(context) {
            let res = await fetch(`${context.getters.persistenceServiceAPI}/Emails`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    ApiKey: context.getters.apiKey
                },
                method: "GET"
            })
            let emails = await res.json();
            context.commit('emails', emails)
        },
        async getEmailKB(context) {
            let res = await fetch(`${context.getters.persistenceServiceAPI}/EmailKnowledgeBase `, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    ApiKey: context.getters.apiKey
                },
                method: "GET"
            })
            let emailKB = await res.json();
            context.commit('userJourney', emailKB)
        },
        async getSignificantTags(context) {

            const token = getSessionToken();

            if (!token) {
                console.error("No session token available. Bootstrap not completed.");
                return;
            }

            let res = await fetch(`${context.getters.modelHub}/SignificantTags `, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-Session-Token": token
                },
                method: "GET"
            })
            let sigTags = await res.json();
            console.info(sigTags);
            context.commit('significantTags', sigTags);
        },
        async setSignificantTags(context, tags) {
            let res = await fetch(`${context.getters.persistenceServiceAPI}/SignificantTags `, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    ApiKey: context.getters.apiKey
                },
                method: "POST",
                body: JSON.stringify(tags)
            })
            let sigTags = await res.json();
            context.commit('significantTags', sigTags)
        },
        async deleteSignificantTag(context, tags) {
            let res = await fetch(`${context.getters.persistenceServiceAPI}/SignificantTags `, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    ApiKey: context.getters.apiKey
                },
                method: "DELETE",
                body: JSON.stringify(tags)
            })
            let sigTags = await res.json();
            context.commit('significantTags', sigTags)
        },
    },
    mutations: {
        userJourney(state, journey) {
            state.userJourney = journey;
        },
/*         emails(state, email) {
            state.emails = email;
        },
        emailKB(state, emailKB) {
            state.emailKB = emailKB;
        }, */
        significantTags(state, sigTags) {
            //alert('set  =' + sigTags);
            state.significantTags = sigTags;
        }
    },
    getters: {
        userJourney(state) {
            return state.userJourney;
        },
/*         emails(state) {
            return state.emails;
        },
        emailKB(state) {
            return state.emailKB;
        }, */
        significantTags(state) {
            //alert('get  =' + state.significantTags);
            return state.significantTags;
        }
    }
}